import React, {PropTypes} from 'react';
import { Row, Col, Image, Media, Panel } from 'react-bootstrap';
import Classnames from 'classnames';

export default class GroupDiscountPanel extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {user} = this.props;

    const potenitalCreditsClass = Classnames({
      "potential-credits-component": true,
      "well": false,
      "cursor-pointer": false
    })

    let groupDiscountPanel = null;
    if (user.group_as_cobrand_member){
      groupDiscountPanel = (
        <Panel className={potenitalCreditsClass}>
          <Media>
              <Media.Left align="middle">
                <img width={25} height={25} src="https://s3.amazonaws.com/cdn.everlance.com/images/dashboard/Gift+Filled-100.png" alt="rewards"/>
              </Media.Left>
              <Media.Body>
                <Media.Heading>You have a group discount.</Media.Heading>
                  <p>Hurray! Upgrade to Premium below to claim your discount.</p>
              </Media.Body>
          </Media>
        </Panel>
      )
    }

    return (<div>
      {groupDiscountPanel}
    </div>);
  }
}

GroupDiscountPanel.propTypes = {
};



// WEBPACK FOOTER //
// ./src/subscriptions/GroupDiscountPanel.js